// extracted by mini-css-extract-plugin
export var container = "dy_c";
export var fadeDiv = "dy_f4";
export var placeholderWrapper = "dy_q5";
export var video = "dy_q6";
export var videoWrapper = "dy_km";
export var vimeoPlayer = "dy_q7";
export var wrapper = "dy_B";